export default __webpack_public_path__ + "static/media/gallery5.9b9a936e.JPG";